// extracted by mini-css-extract-plugin
export default {"promotionPop":"promotionBonusPop_promotionPop__F7pgp","price":"promotionBonusPop_price__H8BDC"};